import $ from 'jquery';

export default () => {
    let people = $('.js-person-grid');
    let windowWidth = window.innerWidth;
    let indicator = 0;
    let _window = $(window);

    people.hover(function (e) {
        let _this = $(this);
        let index = _this.index();
        let thisPrev = _this.prev();
        let thisPrevPrev = thisPrev.prev();

        if (windowWidth < 768)
            return;

        if (!_this.hasClass('-with-hover'))
            return;

        if (indicator === 2) {

            if (index % 2) {
                thisPrev.addClass('move-left');
            }
        }

        if (indicator === 3) {

            if (index % 3) {
                thisPrev.addClass('move-left');

                if (index % 3 === 2) {
                    thisPrevPrev.addClass('move-left');
                }
            }
        }
    },
    function () {
        people.removeClass('move-left');
    });

    function calcClass() {
        windowWidth = window.innerWidth;
        people.removeClass('move-left');

        if (windowWidth < 768)
            return;

        if (windowWidth >= 768 && windowWidth < 992) {
            indicator = 2;
        } else {
            indicator = 3;
        }
    }

    _window.on('resize', function () {
        calcClass();
    });

    calcClass();
}